<template>
  <div class="questions-selector">
    <questions-list
      :questions="unusedQuestions"
      :actions="[{name: 'add', icon: 'add'}]"
      @questionActionClick="question => toggleQuestion(question)"
    >
      <template v-slot:title>
        Select a Question
        <help-tooltip>Press + to add a<br> question to the list</help-tooltip>
      </template>
    </questions-list>
    <questions-list
      :questions="state.selectedQuestions"
      :actions="[{name: 'remove', icon: 'remove'}]"
      @questionActionClick="question => toggleQuestion(question)"
    >
      <template v-slot:title>
        Questions to add
        <help-tooltip>Press - to remove a<br> question from the list</help-tooltip>
      </template>
    </questions-list>
  </div>
</template>

<script>
import uniqBy from 'lodash/uniqBy';
import keyBy from 'lodash/keyBy';

import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

import QuestionsList from './QuestionsList.vue';

export default {
  name: 'questions-selector',
  components: {
    QuestionsList,
    HelpTooltip,
  },
  props: {
    questions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      state: {
        selectedQuestions: [],
      },
    };
  },
  computed: {
    uniqueQuestions() {
      return uniqBy(this.questions, 'content.en');
    },
    unusedQuestions() {
      return this.uniqueQuestions.filter(q => !this.selectedQuestionsMap[q.id]);
    },
    selectedQuestionsMap() {
      return keyBy(this.state.selectedQuestions, 'id');
    },
  },
  methods: {
    toggleQuestion(question) {
      const { selectedQuestions } = this.state;
      if (this.selectedQuestionsMap[question.id]) {
        selectedQuestions.splice(this.state.selectedQuestions.indexOf(question), 1);
      } else {
        selectedQuestions.push(question);
      }
      this.$emit('updateSelectedQuestions', selectedQuestions);
    },
  },
};
</script>

<style scoped>
.questions-selector {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 20px 0;
}
</style>
